module.exports = __webpack_public_path__ + "img/friendlydragonthumb.16af5196.jpg";